import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useDarkMode } from "usehooks-ts";
import classNames from "classnames";
import NotificationContainer from "../components/notification/NotificationContainer";
import SideBar from "./SideBar";
import NavBar from "./NavBar";
import { useLayout } from "../hooks/context/useLayout";
import { ToastContainer } from "react-toastify";
import { useOrgApp } from "../hooks/context/useOrgApp";
import Loading from "../components/common/loading";

const Layout = () => {
  // Dealing with unselect domain 
  const { isSelectedOrg } = useOrgApp();
  // Dealing With Dark Mode
  const { isDarkMode = false } = useDarkMode(false);
  // Dealing with layout/notification/sidebar
  const { showNotification, showSideBar, loadingPage, closeSideBar, closeNotification } = useLayout();

  useEffect(() => {
    document.body.className = classNames({
      modeDark: isDarkMode,
      "notif-show": showNotification,
      "toggled-header": showSideBar,
    });
  }, [isDarkMode, showNotification, showSideBar]);

  // Close the dialog component on off-click component event
  const closeDialogs = (event: any) => {
    const isNotificationClicked = event.target.closest(".menu-notification");
    const isSideBarClicked = event.target.closest(".menu-nav-dashboard");
    // Check if the notif is open, and the click is outside of the notif component
    if (showNotification && !isNotificationClicked) {
      closeNotification();
    }
    // Check if the sidebar is open, and the click is outside of the sidebar component
    if (showSideBar && !isSideBarClicked) {
      closeSideBar();
    }
  }
    
    
  return (
    <>
      {/* Mocking Loading When loadingPage */}
      { loadingPage && <Loading /> }
      <div className={classNames({ "select-domain": !isSelectedOrg(), "d-none": loadingPage })}>
        <div className="main-dashboard" onClick={closeDialogs}>
          <ToastContainer />
          <SideBar />
          <div className="content-dashboard">
            <NotificationContainer />
            <NavBar />
            <div className="detail-content-dashboard">
              {/* Content - Child Component - Pages*/}
              <div className="">
                {/* IF PAGE ISN'T IN LOADING STATE THEN RENDRE THE CHILDREN LAYOUT COMPONENT */}
                { !loadingPage && <Outlet /> }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
